export const columns = [
  { id: 'username', label: 'User ID', width: '160px' },
  { id: 'name', label: 'User name', width: '150px' },
  { id: 'emailId', label: 'Email ID', width: '200px' },
  {
    id: 'role',
    label: 'Business role',
    width: '170px',
    type: 'dropdown',
    options: [
      { label: 'Admin', value: 'ADMIN' },
      { label: 'Preparer', value: 'PREPARER' },
      { label: 'API User', value: 'API_USER' },
    ],
    render: value => {
      const roleMap = {
        ADMIN: 'Admin',
        PREPARER: 'Preparer',
        API_USER: 'API User',
        IT_ADMIN: 'IT Admin',
      }
      if (Array.isArray(value))
        return value.map(v => roleMap[v] || v).join(', ')
      return roleMap[value] || value || 'N/A'
    },
  },
  {
    id: 'isLocked',
    label: 'Is locked',
    width: '100px',
    type: 'dropdown',
    options: [
      { id: 1, label: 'Yes', value: true },
      { id: 2, label: 'No', value: false },
    ],
    // render: value => (value ? 'Yes' : 'No'),
  },
  {
    id: 'isActive',
    label: 'Active',
    width: '120px',
    type: 'dropdown',
    options: [
      { id: 1, label: 'Yes', value: true },
      { id: 2, label: 'No', value: false },
    ],
    render: value => {
      const isActive = value === true || value === 'true' || value === 'Yes'
      return (
        <span
          style={{
            backgroundColor: isActive
              ? 'var(--bg-success)'
              : 'var(--table-header-bg)',
            color: 'var(--forbrand-primary)',
            padding: '4px 8px',
            borderRadius: 4,
            display: 'inline-block',
            fontSize: '12px',
            fontWeight: 500,
          }}
        >
          {isActive ? 'Active' : 'Inactive'}
        </span>
      )
    },
  },
  {
    id: 'isSSOUser',
    label: 'SSO user',
    width: '100px',
    type: 'dropdown',
    options: [
      { id: 1, label: 'Yes', value: true },
      { id: 2, label: 'No', value: false },
    ],
    // render: value => (value ? 'Yes' : 'No'),
  },
  {
    id: 'createdBy',
    label: 'Created by',
    width: '150px',
    minWidth: '120px',
  },
  {
    id: 'createdDate',
    label: 'Created date',
    width: '180px',
  },
  {
    id: 'lastModifiedBy',
    label: 'Updated by',
    width: '150px',
    minWidth: '120px',
  },
  {
    id: 'lastModifiedDate',
    label: 'Updated date',
    width: '180px',
  },
]

// Search fields constant (add Load ID and all columns)
export const searchFields = [
  ...columns.map(col => {
    // Date columns render a native date picker (type: 'date') so the UI offers
    // only date-appropriate operators (EQUAL TO / NOT EQUAL TO / IS NULL /
    // IS NOT NULL) and submits a proper date value. This keeps User setup
    // consistent with the TIN and Entity admin pages (no "date typed as free
    // text" mismatch). The Search component converts the ISO value to the
    // backend dd/mm/yyyy format on apply.
    if (col.id === 'createdDate' || col.id === 'lastModifiedDate') {
      return {
        ...col,
        type: 'date',
        placeholder: 'DD/MM/YYYY',
      }
    }
    return {
      ...col,
      type: col.type || 'text',
      placeholder: `Enter ${col.label}`,
    }
  }),
]
